import React, { type ReactNode } from 'react';

import clsx from 'clsx';
import {
  Tooltip as TooltipWrapper,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip';

interface TooltipProps {
  textFirst: string | ReactNode;
  textSecond: string | ReactNode;
  className: string;
  classNameTooltipContent?: string;
  children: ReactNode;
  position?: 'top' | 'bottom' | 'left' | 'right';
}

export const Tooltip: React.FC<TooltipProps> = ({
  className,
  classNameTooltipContent = '',
  textFirst = 'Underline',
  textSecond = '⌘K->T',
  children,
  position = 'top',
}) => {
  function renderContent(content: string | ReactNode) {
    if (typeof content === 'string') {
      // Support <br /> by splitting on <br /> or <br> or \n
      const parts = content.split(/<br\s*\/?>|\n/gi);
      return parts.map((part, idx) => (
        <React.Fragment key={idx}>
          {part}
          {idx < parts.length - 1 && <br />}
        </React.Fragment>
      ));
    }
    return content;
  }
  return (
    <div className={clsx('', className)}>
      <TooltipProvider>
        <TooltipWrapper>
          <TooltipTrigger asChild>{children}</TooltipTrigger>
          <TooltipContent
            side={position}
            className={clsx('flex items-center gap-2 bg-[#141B24]', classNameTooltipContent)}
          >
            {textFirst !== '' && (
              <span className="text-body-xs text-white">{renderContent(textFirst)}</span>
            )}
            {textSecond !== '' && (
              <span className="text-body-xs text-[#808791]">{renderContent(textSecond)}</span>
            )}
          </TooltipContent>
        </TooltipWrapper>
      </TooltipProvider>
    </div>
  );
};
